import { DateCondition, FieldListObject } from '@fabric-ui/components';
import { getCollectExpression } from '@views/CustomDashboards/CustomDashboardsUtils/expressionUtils';
import { clickthroughPrefix, clickthroughWidgetId } from './consts';

export const getFiltersWithoutKeyPrefix = (filters: Record<string, any>, keyPrefix = clickthroughPrefix): Record<string, any> =>
  Object.keys(filters).reduce(
    (acc, cur) => ({
      ...acc,
      ...(cur.startsWith(keyPrefix) ? {} : { [cur]: filters[cur] }),
    }),
    {}
  );

export enum ProgressClickthroughState {
  PercentageComplement,
  NotPercentageComplement,
  NonActive,
}

export const getParamFromURL = <T>(param: T | T[]) => (Array.isArray(param) ? param[0] : param);

export const closeClickthrough = ({ filters }: { filters: Record<string, any> }) => {
  const widgetId = getParamFromURL<string>(filters[clickthroughWidgetId]);
  if (widgetId) sessionStorage.removeItem(`clickthrough_viewModified_${widgetId}`);
  const { viewId, ...filtersWithoutClickthroughParams } = getFiltersWithoutKeyPrefix(filters);
  return filtersWithoutClickthroughParams;
};

export function getDims({
  dims,
  isCollectEnabled,
  timeRange,
  fieldMap,
  clickthroughProj,
}: {
  dims: string[];
  isCollectEnabled: boolean;
  timeRange?:
    | DateCondition
    | {
        between: {
          values: string[];
        };
      };
  fieldMap: Record<string, FieldListObject>;
  clickthroughProj: { name: string };
}): { name: string; alias?: string; expression? }[] {
  if (isCollectEnabled) {
    if (timeRange) {
      return dims.map(dimName =>
        fieldMap[dimName].mainProjId.name === clickthroughProj.name && fieldMap[dimName].name === '_key'
          ? { name: dimName }
          : { name: dimName, alias: `${dimName}_collect`, expression: getCollectExpression(dimName, fieldMap[dimName].repeated) }
      );
    }

    return dims.map(dimName =>
      fieldMap[dimName].mainProjId.name === clickthroughProj.name
        ? { name: dimName }
        : { name: dimName, alias: `${dimName}_collect`, expression: getCollectExpression(dimName, fieldMap[dimName].repeated) }
    );
  }

  return dims.map(dimName => ({ name: dimName }));
}

export function getTitleForDimWithCollectExpression(dimTitle: string): string {
  return `${dimTitle} (Multiple)`;
}
